import { render, staticRenderFns } from "./ProductsModal.vue?vue&type=template&id=6dd5e7f5&"
import script from "./ProductsModal.vue?vue&type=script&lang=js&"
export * from "./ProductsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductsModal.vue?vue&type=style&index=0&id=6dd5e7f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports